import { render } from "./cupom.vue?vue&type=template&id=581f9d04&scoped=true"
import script from "./cupom.vue?vue&type=script&lang=js"
export * from "./cupom.vue?vue&type=script&lang=js"

import "./cupom.vue?vue&type=style&index=0&id=581f9d04&scoped=true&lang=css"
import "./cupom.vue?vue&type=style&index=1&id=581f9d04&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581f9d04"]])

export default __exports__